<div class="row">
  <div class="col">
    <button class="btn btn-danger ml-2" (click)="voltar()"><i class="fas fa-reply"></i></button>
  </div>
  <div class="col">
    <button class="btn btn-outline-secondary btn-sm float-right mr-2" (click)="exportarExcel()">
      <em class="fa fa-download fa-xs"></em>
      Export Excel
    </button>
  </div>
</div>
<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="content">
      <p-table #dt dataKey="id" [value]="tempDados.dados" selectionMode="single" styleClass="p-datatable-responsive-demo
          p-datatable-striped
          p-datatable-sm" [columns]="selectedColumns" [columns]="cols" [value]="rows" [autoLayout]="true"
        currentPageReportTemplate="{{'estoque.ampDetalhado.mostrandoRegistros' | translate}}"
        [rowsPerPageOptions]="[10,20,30,50,100]" [showCurrentPageReport]="true" [paginator]="true" [rows]="10"
        id="excel-table">
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col style="width: 150px;">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [translate]="getTranslate(col.header)" [pSortableColumn]="col.field" class="text-center"
              *ngFor="let col of columns" style="background-color:black;color:white;">
              {{col.header}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dados let-columns="columns">
          <tr>
            <td class="text-center percentual" *ngFor="let col of columns">
              <div [ngClass]="{'text-center': col.field !== 'codigo_dealer' && col.field !== 'nome_dealer'}">
                {{ col.type ? col.type.transform(dados[col.field], col.arg1, col.arg2, col.arg3) : dados[col.field] }}
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr *ngFor="let total of tempDados?.total">
            <td class="text-center" style="background-color:black;color:white;">
              {{tempDados.dados[0].nome_dealer}}
            </td>
            <td class="text-center" style="background-color:black;color:white;">
              {{total.estoque | number: '1.0-0'}}
            </td>
            <td class="text-center" style="background-color:black;color:white;">
              {{total.manter | number: '1.0-0'}}
            </td>
            <td class="text-center" style="background-color:black;color:white;">
              {{total.comprar | number: '1.0-0'}}
            </td>
            <td class="text-center percentual" style="background-color:black;color:white;">
              {{total.percentual | percent: '1.0-0'}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <p-button type="button" styleClass="p-button-text"></p-button>
        </ng-template>
        <ng-template pTemplate="paginatorright">
          <p-button type="button" styleClass="p-button-text"></p-button>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
